import { EpimsBaseEntityDto } from './epim-base.dto';
export class TerrainDto extends EpimsBaseEntityDto {

    TerrainId: string;
    TerrainDate: Date;
    Status: string;
    Remarks: string;
    TerrainName: string;
    RateStatusId: string;
    Rate: string;
}
